import { Box } from "@components/Layout"
import { LabelStyle } from "@components/Typography/TextStyles/Label"
import { TitleMStyle } from "@components/Typography/TextStyles/TitleM"
import { breakpoints } from "@config/theme"
import { rem } from "polished"
import styled from "styled-components"

export const Container = styled(Box)`
  width: 100%;
  text-align: center;
  flex-wrap: wrap;

  p {
    margin-bottom: 0;
    font-size: ${rem(14)};
  }

  span {
    display: inline-block;
    margin: 0 0.5rem;
  }
`

export const ActiveComponent = styled.h4`
  ${LabelStyle};
  color: ${(p) => p.theme.colors.text.light};
`

export const Title = styled.h1`
  ${TitleMStyle};
  padding: 0.75rem 0;

  @media screen and (max-width: ${breakpoints.xlarge}) {
    padding: 0;
  }
`
